import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('Search', function (props) {
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("circle", {
    fill: "transparent",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin,
    cx: "21",
    cy: "21",
    r: "17"
  }), React.createElement("path", {
    d: "M26.6568542,14.3431458 C25.209139,12.8954305 23.209139,12 21,12 C18.790861,12 16.790861,12.8954305 15.3431458,14.3431458",
    stroke: "currentColor",
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M31.4644661,37.4644661 L43.4644661,37.4644661",
    stroke: "currentColor",
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(37.464466, 37.464466) rotate(45.000000) translate(-37.464466, -37.464466)"
  }))));
});